import React from 'react'
// icons
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined'
// components
import ExportMenu from '../Menu'
import { PopoverModal } from 'components/UI'
// views
import { Wrapper, MenuItem, MenuItemLabel } from './views'
// types
import { IRiskTemplate } from 'types/graphql'

const DOCX_POPOVER_PROPS = {
  anchorOrigin: { vertical: 'top' as const, horizontal: 'left' as const },
  transformOrigin: { vertical: 'top' as const, horizontal: 'right' as const }
}

interface Props {
  closePopup: () => void
  relatedForms: { riskId: string; riskTemplate: IRiskTemplate }[]
  generateDocument: (...args: any) => void
  generatePdf: () => Promise<void>
}

const TopMenu: React.FC<Props> = ({ closePopup, relatedForms, generateDocument, generatePdf }) => {
  const handleExportPdf = async (e: React.MouseEvent) => {
    e.stopPropagation()
    closePopup()
    await generatePdf()
  }

  return (
    <Wrapper>
      <PopoverModal
        {...DOCX_POPOVER_PROPS}
        trigger={
          <MenuItem>
            <InsertDriveFileOutlinedIcon fontSize='small' />
            <MenuItemLabel>Export as DOCX</MenuItemLabel>
          </MenuItem>
        }
      >
        {({ closePopup: closeDocxPopup }) => (
          <ExportMenu
            closePopup={() => { closeDocxPopup(); closePopup() }}
            relatedForms={relatedForms}
            generateDocument={generateDocument}
          />
        )}
      </PopoverModal>
      <MenuItem onClick={handleExportPdf}>
        <PictureAsPdfOutlinedIcon fontSize='small' />
        <MenuItemLabel>Export as PDF</MenuItemLabel>
      </MenuItem>
    </Wrapper>
  )
}

export default TopMenu
